import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  standalone: true,
  selector: 'app-ag-user-info-renderer',
  template: `
    <div class="user-info-cell">
      <div class="avatar">{{ initials }}</div>
      <div class="user-details">
        <span class="user-name">{{ userName }}</span>
        <span class="user-email">{{ userEmail }}</span>
      </div>
    </div>
  `,
  styleUrls: ['./ag-user-info-renderer.component.scss'],
})
export class AgUserInfoRendererComponent implements ICellRendererAngularComp {
  userName = '';
  userEmail = '';
  initials = '';

  agInit(params: ICellRendererParams): void {
    this.userName = params.data?.userName || '';
    this.userEmail = params.data?.userEmail || '';
    this.initials = this.getInitials(this.userName);
  }

  refresh(): boolean {
    return false;
  }

  private getInitials(name: string): string {
    if (!name) {
      return '';
    }
    return name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  }
}
